/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BookmarksWidgetContainer_user$ref: FragmentReference;
export type BookmarksWidgetContainer_user = {|
  +id: string,
  +$refType: BookmarksWidgetContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "BookmarksWidgetContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1116745567fbd3546789253d635752ac';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Widget/Widgets/Bookmarks/__generated__/BookmarksWidgetContainer_user.graphql.js